import './index.less';

import commonMsg from 'messages';
import loginMsg from 'messages/Login';
import { Button, Icon, Input } from '@beehive/components';
import PropTypes from 'prop-types';
import React, { ChangeEvent } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Captcha from './Captcha';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { isBlank } from 'utils';
import * as actions from 'modules/actions/account';
import * as qs from 'querystring';
import _ from 'lodash';
import { encryptPassword } from 'utils/encryptPassword';

const messages = { ...commonMsg, ...loginMsg };
const PWD_KEYS = {
  password: {
    placehholderKey: 'newPwd',
  },
  password_confirmation: {
    placehholderKey: 'newPwdAgain',
  },
};
export interface ResetPwdProps extends RouteComponentProps {
  prefixCls?: string;
  resetPwd: Function;
  checkLink: Function;
}
class ResetPwd extends React.Component<ResetPwdProps, any> {
  private refreshRef: any;
  static contextTypes = {
    intl: PropTypes.object,
  };
  static defaultProps = {
    prefixCls: 'mpc-external-login-forget-pwd',
  };
  constructor(props: ResetPwdProps) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const { checkLink } = this.props;
    const querystringInfo = qs.parse(location.hash.slice(location.hash.indexOf('key')));
    checkLink(querystringInfo).then((res: any) => {
      if (res.res_code === -1) {
        this.setState({ showErrorPage: true });
      }
    });
  }
  handleSubmit = () => {
    const { intl } = this.context;
    const { resetPwd } = this.props;
    const { password, password_confirmation, verifyCode } = this.state;
    const alertMsg = this.getAlertMsg();
    if (alertMsg) {
      return;
    }
    this.setState({ submitLoading: true });
    const querystringInfo = qs.parse(location.hash.slice(location.hash.indexOf('key')));
    const body = {
      password: encryptPassword(password),
      password_confirmation: encryptPassword(password_confirmation),
      _rucaptcha: verifyCode,
      ...querystringInfo,
      encrypted: true,
    };
    resetPwd(body).then((res: any) => {
      const mess = _.get(res, 'data.messages');
      if (!mess) {
        this.setState({ showIconPage: true, submitLoading: false });
      } else {
        this.refreshRef({
          locale: intl.locale,
          onChange: this.handleChange,
        });
        this.setState({ alertMsg: _.values(mess)[0], verifyCode: null, submitLoading: false });
      }
    });
  }
  handleChange = (newVal: { [key: string]: any }) => {
    const { errorKey, alertMsg } = this.state;
    let newErrorKey = errorKey;
    let newAlertMsg = alertMsg;
    if (!!~Object.keys(newVal).indexOf(errorKey)) {
      newErrorKey = null;
      newAlertMsg = null;
    }
    const val = {
      ...this.state,
      ...newVal,
      errorKey: newErrorKey,
      alertMsg: newAlertMsg,
    };
    this.setState(val);
  }
  handleShowType = (index: number, val: boolean) => {
    this.setState({ [`pwdType_${index}`]: val });
  }
  handleClick = () => {
    const { history } = this.props;
    window.location.href = 'https://' + window.location.host + '/login'
  }
  getRefreshRef = (refresh: any) => {
    this.refreshRef = refresh;
  }
  getPwdItem = () => {
    const { intl } = this.context;
    const { errorKey } = this.state;
    return Object.keys(PWD_KEYS).map((key: string, index: number) => {
      const val = this.state[key];
      const type = this.state[`pwdType_${index}`];
      return (
        <Input
          key={key}
          className={`mpc-external-login-form-item ${errorKey === key ? 'show-error' : ''}`}
          placeholder={intl.formatMessage(messages[PWD_KEYS[key].placehholderKey])}
          prefix={<Icon name="lock-o" />}
          suffix={
            <Icon
              size={10}
              name={type ? 'display-o' : 'hide-o'}
              onClick={() => this.handleShowType(index, !type)}
            />
          }
          type={type ? 'input' : 'password'}
          onChange={(e: ChangeEvent<HTMLInputElement>) => this.handleChange({ [key]: e.target.value })}
          value={val}
        />
      );
    });
  }
  getAlertMsg = () => {
    const { intl } = this.context;
    const { password, password_confirmation, verifyCode } = this.state;
    let alertMsg = null;
    let errorKey = null;
    switch (true) {
      case isBlank(password): {
        alertMsg = intl.formatMessage(messages.inputNewPwd);
        errorKey = Object.keys(PWD_KEYS)[0];
        break;
      }
      case isBlank(password_confirmation): {
        alertMsg = intl.formatMessage(messages.confirmPwd);
        errorKey = Object.keys(PWD_KEYS)[1];
        break;
      }
      case password_confirmation !== password: {
        alertMsg = intl.formatMessage(messages.diffPwd);
        errorKey = Object.keys(PWD_KEYS)[1];
        break;
      }
      case isBlank(verifyCode): {
        alertMsg = intl.formatMessage(messages.captchaAlertMsg);
        errorKey = 'verifyCode';
        break;
      }
      default: {
        //
      }
    }
    this.setState({ alertMsg, errorKey });
    return alertMsg;
  }
  render() {
    const { intl } = this.context;
    const { prefixCls } = this.props;
    const { alertMsg, submitLoading, showIconPage, showErrorPage } = this.state;
    if (showIconPage) {
      return (
        <div className={`mpc-external-login mpc-external-login-wrap ${prefixCls}-wrap`}>
          <div className="verify-messages">
            <Icon name="check-circle-o" size={80} />
            <div className="verify-title">{intl.formatMessage(messages.resetSuccess)}</div>
            <Button link onClick={this.handleClick}>{intl.formatMessage(messages.loginNow)}</Button>
          </div>
        </div>
      );
    } else if (showErrorPage) {
      return (
        <div className={`mpc-external-login mpc-external-login-wrap ${prefixCls}-wrap`}>
          <div className="verify-messages verify-error">
            <Icon name="exclamation-circle-o" size={80} />
            <div className="verify-title">{intl.formatMessage(messages.uselessLink)}</div>
            <Button link onClick={this.handleClick}>{intl.formatMessage(messages.backToLogin)}</Button>
          </div>
        </div>
      );
    } else {
      return (
        <div className={`mpc-external-login mpc-external-login-wrap ${prefixCls}-wrap`}>
          <div className={`${prefixCls}-title strong`}>{intl.formatMessage(messages.resetPassword)}</div>
          {this.getPwdItem()}
          <Captcha
            locale={intl.locale}
            onChange={this.handleChange}
            getRefreshRef={this.getRefreshRef}
          />
          <div className={`${prefixCls}-alert-msg mpc-external-login-alert-msg`}>
            {
              alertMsg && <Icon name="exclamation-circle-o" />
            }
            {alertMsg}
          </div>
          <Button
            type="primary"
            className={`${prefixCls}-next-btn`}
            onClick={this.handleSubmit}
            disabled={submitLoading}
          >
            {intl.formatMessage(messages.resetPassword)}
          </Button>
        </div>
      );
    }
  }
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AccountActions>) {
  return bindActionCreators({
    resetPwd: actions.resetPwd,
    checkLink: actions.checkLink,
  }, dispatch);
}

export default connect(undefined, mapDispatchToProps)(ResetPwd);
